import { useCallback } from "react";
import { CellValueChangedEvent } from "ag-grid-community";
import { showWarning } from "src/utils/toast/toastUtil";
import { HRM2130_R01Dto } from "../Dto_HRM2130_R01";
import { ATTEND_GROUP_OUTING } from "../Util_HRM2130_R01";

interface Props {
    updateHRM2130_R01List: (index: number, data: HRM2130_R01Dto) => void;
}

/**
 * 일반 셀 편집 결과를 Store에 반영하는 화면 전용 훅이다.
 * @returns 그리드 onCellValueChanged에 연결할 handleCellChange
 */
export const useHRM2130_R01CellChange = ({ updateHRM2130_R01List }: Props) => {
    /** 변경된 필드와 값을 반영한다. 유효하지 않은 행·필드는 무시하고 반환값은 없다. */
    const handleCellChange = useCallback((event: CellValueChangedEvent<HRM2130_R01Dto>) => {
        const { data, colDef, newValue } = event;
        // 합계 행 등 실제 데이터가 없거나 필드가 없는 이벤트는 처리하지 않는다.
        if (!data || !colDef.field) return;
        const field = colDef.field as keyof HRM2130_R01Dto;

        // 외출(G5)이 아닌 행의 근무인정 변경은 경고하고 Y로 되돌린 뒤 종료한다.
        if (field === 'workYn' && data.attendGroup !== ATTEND_GROUP_OUTING) {
            showWarning('근무인정은 외출(G5) 코드에서만 변경할 수 있습니다.');
            updateHRM2130_R01List(data.valueIndex, { ...data, workYn: 'Y' });
            return;
        }
        const updated = { ...data, [field]: newValue, isModified: true };
        // 근태구분을 G5 이외로 바꾸면 근무인정을 Y로 함께 갱신한다.
        if (field === 'attendGroup' && newValue !== ATTEND_GROUP_OUTING) {
            updated.workYn = 'Y';
        }
        updateHRM2130_R01List(data.valueIndex, updated);
    }, [updateHRM2130_R01List]);

    // Table에서 이벤트 핸들러를 연결할 수 있도록 반환한다.
    return { handleCellChange };
};
